<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 checklistTempTab"
                    :data="contract_tab"
                    :query-param="{id:$route.params.id}"
                    activeKey="finance"
                    arrows >
                    <template slot="gofixTab:finance">
                        <div class="mb-3 mt-2 text-right"><gofix-button label="Save" :disabled="!isAllowSetting" @click="save" outline></gofix-button></div>
                        <gofix-card title=" " class="mb-0 heig-frame-child" classHeader="mb-0">
                            <b-row>
                                <b-col md="12">
                                    <p><i><strong><span>*</span> If supplier is under LMU project to allow setting.</strong></i></p>
                                </b-col>
                            </b-row>
                            <b-row align-v="center">
                                <b-col md="3">
                                    <b-form-checkbox :disabled="!isAllowSetting" v-model="finance.is_non_chargeable" class="checkbox-main-allow mt-0"><span class="ml-2">Non-Chargeable</span></b-form-checkbox>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-input-number
                                        label="Chargeable non-approval line item limit"
                                        prefix="$"
                                        :disabled="!isAllowSetting"
                                        v-model="finance.chargeable_non_approval_line_item_limit"/>
                                </b-col>
                            </b-row>
                            <b-row align-v="center">
                                <b-col md="5">
                                    <b-form-checkbox v-model="finance.allow_supplier_add_ap_line_item_without_verification" class="checkbox-main-allow mt-0">
                                        <span class="ml-2">Allow Supplier to add AP Invoice LineItem without any verification</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>    
                            
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import tabData from '@/data/_tabs';
    const accounting = require('accounting');
    export default {
        name: 'supplier-finance',
        data() {
            return {
                contract_tab: tabData.supplier_contract,
                finance: {
                    is_non_chargeable: false,
                    chargeable_non_approval_line_item_limit: "",
                    allow_supplier_add_ap_line_item_without_verification:false
                },
                timer: null,
                loading: false,
            }
        },
        computed: {
            ...mapGetters({
                SContract: 'ContractController/SContract',
            }),
            isAllowSetting() {
                if(!this.SContract || (this.SContract && !this.SContract.is_supplier_under_lmu_project)) return false
                return true
            }
        },
        watch: {
            SContract: function(val) {
                if(val && val.lmu_settings) {
                    this.formatData(val.lmu_settings);
                } else {
                    this.finance = {
                        is_non_chargeable: false,
                        chargeable_non_approval_line_item_limit: "",
                        allow_supplier_add_ap_line_item_without_verification:false
                    }
                }
            }
        },
        created() {
            if(this.SContract && this.SContract.lmu_settings) {
                this.formatData(this.SContract.lmu_settings);
            } else {
                this.getContract();
            }
        },
        methods: {
            formatData(val) {
                this.finance = Object.assign(this.finance, val);
                if(this.finance.lmu_settings && this.finance.lmu_settings.chargeable_non_approval_line_item_limit) this.$accounting.formatMoney(this.finance.lmu_settings.chargeable_non_approval_line_item_limit);
            },
            getContract() {
                this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id)
                .catch(error => { 
                    this.$router.push(`/v2/contract-supplier`) 
                })
            },
            save() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    this.loading = true;
                    let objClone = {
                        contract_id: this.SContract.id,
                        client_id: this.SContract.client_id,
                        supplier_id: this.SContract.supplier_id,
                        contract_name: this.SContract.contract_name,
                        abbreviation: this.SContract.abbreviation,
                        description: this.SContract.description,
                        deposit_amount: this.SContract.deposit_amount,
                        issuing_bank: this.SContract.issuing_bank,
                        deposit_expiry: this.SContract.deposit_expiry,
                        insurance_expiry: this.SContract.insurance_expiry,
                        insurance_excess: this.SContract.insurance_excess,
                        insurance_type: this.SContract.insurance_type,
                        timezone: this.SContract.timezone,
                        lmu_settings: this.finance
                    }

                    objClone.lmu_settings.chargeable_non_approval_line_item_limit = accounting.unformat(objClone.lmu_settings.chargeable_non_approval_line_item_limit);
                    objClone.lmu_settings = JSON.stringify(objClone.lmu_settings);
                    this.$store.dispatch('ContractController/UpdateSupllierContract', objClone)
                    .then(response => {
                        this.loading = false;
                        this.$alertNotification(this.$notificationV2('editing', 'supplier_finance'));
                    })
                    .catch(error => {
                        this.loading = false;
                    });
                }, 200);
            }
        }
    }
</script>